import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

export const initialState = {
  threadList: null,
  selectedthread: null,
  loading: false,
  error_message: false,
  error:true,
  temp_selected_thread_title: null,
  update_thread_id:null,
  update_thread_title: null,
  
 
};

const Thread_Slice = createSlice({
  name: "Thread",
  initialState,
  reducers: {
    fetch_thread_list_success(state, action) {
       state.threadList = action.payload.data.length > 0 ?  action.payload.data : null;
       state.temp_selected_thread_title = " "
       state.selectedthread = action.payload?.data[0];
       state.loading = false;
       state.error = false;

      
    },
    fetch_thread_list_failed(state, action) {
      
       
        state.loading = false;
        state.error = true;
        state.error_message = action.payload
        state.selectedthread=null
      //   state.threadList=[]
 
       
     },
     fetch_thread_list_start_loading(state, action) {
         state.loading = true;
     },
     delete_thread_sucsess(state, action){
        state.loading = false
     },
     delete_thread_fail(state,action){
        state.loading = false
        state.error=true
        state.error_message=action.payload
        
     },
     create_thread_fail(state,action){
      state.loading = false
      state.error=true
      state.error_message=action.payload
      
     },
     change_selected_thread(state, action){
      // console.log(action.payload , "Chnage thread selected ");
      state.temp_selected_thread_title=""
      state.selectedthread = action.payload
     },
     reset_thread_list(state){
      state.threadList= null
      state.selectedthread= null
      state.loading= false
      state.temp_selected_thread_title= null
      state.error_message= false
      state.error=true
      state.temp_selected_thread_title= null
      state.update_thread_id=null
      state.update_thread_title=null
            
     },
     set_temp_thread_title(state, action){
       const {thread_id , title}= action.payload
       state.temp_selected_thread_title = title

       const temp_thread_list = state.threadList.map((thread)=>{
              if(thread.thread_id === thread_id){
                  thread.title = title
                  return thread
              }else{
                  return thread
              }
       })


        state.threadList = temp_thread_list
     },
     set_edit_thread_id_title(state, action){
      const { thread_id , title }= action.payload
      state.update_thread_id = thread_id
      state.update_thread_title = title
     },
     reset_thread_reducer:() => initialState


     

  },
});

export const {
   set_temp_thread_title,
    fetch_thread_list_success,
    fetch_thread_list_failed,
    fetch_thread_list_start_loading,
    delete_thread_sucsess,
    delete_thread_fail,
    create_thread_fail,
    change_selected_thread,
    reset_thread_list, 
    reset_thread_reducer,
    set_edit_thread_id_title
} = Thread_Slice.actions

export default Thread_Slice.reducer;